export var FilterStatus;

(function (FilterStatus) {
  FilterStatus["All"] = "all";
  FilterStatus["Read"] = "read";
  FilterStatus["Unseen"] = "unseen";
  FilterStatus["Unread"] = "unread";
})(FilterStatus || (FilterStatus = {}));

export var FilterStatusToLabel = {
  [FilterStatus.All]: "All",
  [FilterStatus.Unread]: "Unread",
  [FilterStatus.Read]: "Read"
};
//# sourceMappingURL=constants.js.map